module.exports = __webpack_public_path__ + "img/icon_search_color.b09e97d3.svg";